import {
    Flex,
    Heading,
    Icon,
    Icons,
    ThemeColorVariable,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

interface IChoiceHeaderProps {
    id?: string;
    icon?: Icons;
    text: string;
    mb?: ThemeSpaceVariable;
}

const SelectionHeader = ({ id, icon, text, mb }: IChoiceHeaderProps) => {
    return (
        <Flex
            alignItems="center"
            gap={ThemeSpaceVariable.Small}
            mb={mb ? mb : ThemeSpaceVariable.Medium}
            userSelect="none"
        >
            {icon && (
                <Icon
                    alignSelf="flex-start"
                    icon={icon}
                    size={ThemeIconSizeVariable.Large}
                    color={ThemeColorVariable.OnBackgroundHeader}
                />
            )}
            <Heading as="h3" id={id}>
                {text}
            </Heading>
        </Flex>
    );
};

export default SelectionHeader;
